import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AttendanceComponent } from './component/attendance/attendance.component';
import { AbsenceRequestComponent } from './component/absence-request/absence-request.component';
import { OvertimeComponent } from './component/overtime/overtime.component';
import { EmployeeDetailsComponent } from './component/employee-details/employee-details.component';
import { AttendanceGridComponent } from './component/attendance-grid/attendance-grid.component';
import { AttendanceRegularizationComponent } from './component/attendance-regularization/attendance-regularization.component';
import { AddAttendanceRegularizationComponent } from './component/attendance-regularization/add-attendance-regularization/add-attendance-regularization.component';
import { TnaAuthorisationComponent } from './component/tna-authorisation/tna-authorisation.component';
import { FieldMappingComponent } from './component/field-mapping/field-mapping.component';
import { AddFieldMappingComponent } from './component/field-mapping/add-field-mapping/add-field-mapping.component';
import { StagingAuditComponent } from './component/staging-audit/staging-audit.component';

const routes: Routes = [
  {
    path: 'list-view',
    component: AttendanceComponent,
    data: { breadcrumb: 'Attendance List' },
  },
  {
    path: 'absencerequest',
    component: AbsenceRequestComponent,
    data: { breadcrumb: 'Absence Request' },
  },
  {
    path: 'overtime',
    component: OvertimeComponent,
    data: { breadcrumb: 'Overtime' },
  },
  {
    path: 'employeedetails',
    component: EmployeeDetailsComponent,
    data: { breadcrumb: 'employee Details' },
  },
  {
    path: '',
    component: AttendanceGridComponent,
    data: { breadcrumb: 'Attendance' },
  },
  // {
  //   path: 'attendance-regularization/request',
  //   component: AttendanceRegularizationComponent,
  //   data: { breadcrumb: 'Attendace Regularization' }
  // },
  // {
  //   path: 'attendance-regularization/request/:id',
  //   component: AttendanceRegularizationComponent,
  //   data: { breadcrumb: 'Attendace Regularization' }
  // },
  // {
  //   path: 'attendance-regularization/approve',
  //   component: AttendanceRegularizationComponent,
  //   data: { breadcrumb: 'Attendace Regularization Approve' }
  // }

  {
    path: 'apply-attendance-regularization',
    component: AttendanceRegularizationComponent,
    data: { breadcrumb: 'Attendance Regularization Request' },
  },
  {
    path: 'approve-attendance-regularization',
    component: AttendanceRegularizationComponent,
    data: { breadcrumb: 'Attendance Regularization Approve' },
  },
  {
    path: 'apply-attendance-regularization/add',
    component: AddAttendanceRegularizationComponent,
    data: { breadcrumb: 'Create Attendance Regularization' },
  },
  {
    path: 'apply-attendance-regularization/:id',
    component: AddAttendanceRegularizationComponent,
    data: { breadcrumb: 'Update Attendance Regularization' },
  },
  {
    path: 'approve-attendance-regularization/add',
    component: AddAttendanceRegularizationComponent,
    data: { breadcrumb: 'Attendance Regularization' },
  },
  {
    path: 'approve-attendance-regularization/:id',
    component: AddAttendanceRegularizationComponent,
    data: { breadcrumb: 'Attendance Regularization Approve' },
  },
  {
    path: 'tna-authorisation',
    component: TnaAuthorisationComponent,
    data: { breadcrumb: 'TNA Authorisation' },
  },
  {
    path: 'field-mapping',
    component: FieldMappingComponent,
    data: { breadcrumb: 'Field Mapping' },
  },
  {
    path: 'field-mapping/add',
    component: AddFieldMappingComponent,
    data: { breadcrumb: 'Field Mapping' },
  },
  {
    path: 'field-mapping/edit/:id',
    component: AddFieldMappingComponent,
    data: { breadcrumb: 'Field Mapping' },
  },
  {
    path: 'staging-audit',
    component: StagingAuditComponent,
    data: { breadcrumb: 'Staging Data Audit' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AttendanceRoutingModule {}
